<template>
  <div>
    <div class="content">
      <div class="title">
        <span>支付信息</span>
      </div>
      <ul>
        <li>
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>处方号：</span>
            <span>{{ orderInfo.medicalAdviceCode }}</span>
          </p>
        </li>
        <li>
          <div>
            <p>
              <span>科室：</span>
              <span>{{ orderInfo.creatorDeptName }}</span>
            </p>
            <p>
              <span>医师：</span>
              <span>{{ orderInfo.operateUser }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>年龄：</span>
              <span>{{ orderInfo.patientAge }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p v-if="orderInfo.patientType == 1">
              <span>就诊号：</span>
              <span>{{ orderInfo.patientVisitNo }}</span>
            </p>
            <p v-else>
              <span>住院号：</span>
              <span>{{ orderInfo.patientHospitalNo }}</span>
            </p>
            <p>
              <span>类型：</span>
              <!-- <span v-if="orderInfo.adviceType === 4">预交费</span> -->
              <span>营养医嘱</span>
              <!-- <span v-if="orderInfo.adviceType === 6">宣教医嘱</span> -->
            </p>
          </div>
        </li>

        <li>
          <span>开具日期：</span>
          <span>{{ orderInfo.createTime }}</span>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.totalAmount || 0 }}</span>
            <span
              v-if="orderInfo.orderStatus === 1"
              style="color: var(--basic-red)"
            >
              未缴费
            </span>
            <span
              v-if="orderInfo.orderStatus === 2"
              style="color: var(--basic-red)"
            >
              支付中
            </span>
            <span
              v-if="orderInfo.orderStatus === 3"
              style="color: var(--basic-green)"
            >
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span>
            <span v-if="orderInfo.orderStatus === 6">已作废，请重新开具</span>
          </p>
        </div>
        <div style="padding-bottom: 70px">
          <img
            v-if="receiveType == 1 && orderInfo.patientType == 1"
            style="margin-top: 20px"
            src="@/assets/img/prescriptionMap.png"
            alt=""
          />
        </div>
        <div class="btnContent">
          <van-button
            v-if="orderInfo.orderStatus === 1"
            @click="payment"
            round
            size="small"
            type="success"
          >
            立即支付
          </van-button>
          <van-button
            v-if="orderInfo.orderStatus === 3"
            @click="openInvoice"
            round
            size="small"
            type="success"
          >
            发票开具
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    srmquestInvoicePrescription,
    weixinpay,
  } from '@/api/prescription/prescription'
  import { reactive, toRefs } from 'vue'
  // import { requestWechatCode } from "@/api/wechat/wechatAuto";
  import moment from 'moment'
  import { useRoute, useRouter } from 'vue-router'

  export default {
    mounted() {},
    methods: {},
    setup() {
      const route = useRoute()
      const router = useRouter()
      const state = reactive({
        dialogShow: true,
        orderInfo: '',
        medicalAdviceCode: route.query.adviceCode,
        category: route.query.category,
        receiveType: 2,
        receivingAddress: '',
        receivingRemark: '',
        receivingPhone: null,
        receivingUser: '',
        agree: [],
        disabled: true,
        url: '',
        appid: null,
        code: route.query.code,
        openid: route.query.openid,
      })

      // 获取支付信息接口
      srmquestInvoicePrescription({
        adviceCode: state.medicalAdviceCode,
        category: state.category,
      }).then(v => {
        const { data } = v
        state.orderInfo = data
        state.paymentAddress = data.paymentUrl
        state.receivingUser = data.receivingUser
        state.receivingPhone = data.receivingPhone
        state.receivingAddress = data.receivingAddress
        state.orderInfo.createTime = moment(state.orderInfo.createTime).format(
          'YYYY-MM-DD HH:mm:ss',
        )
        state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2)
      })

      function payBtn() {
        const data = {
          adviceCode: route.query.adviceCode,
          category: route.query.category,
          openid: state.openid,
        }

        weixinpay(data).then(v => {
          const data = JSON.parse(v.data)
          wx.config({
            debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.paySign, // 必填，签名
            jsApiList: ['chooseWXPay', 'checkJsApi'], // 必填，需要使用的JS接口列表
          })

          wx.ready(() => {
            wx.chooseWXPay({
              appId: data.appId,
              timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
              package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.paySign, // 支付签名
              success: function (payRes) {
                // 支付成功后的回调函数
              },
              cancel: function (payRes) {
                // that.$message.error('取消支付')
              },
              fail: function (payRes) {
                // that.$message.error('支付失败')
              },
            })
          })
        })
      }

      // 支付方法
      const payment = () => {
        payBtn()
      }

      const openUsage = () => {
        router.push({
          path: '/prescription/usage',
          query: { id: state.orderInfo.medicalAdviceId },
        })
      }

      // 开具发票
      const openInvoice = () => {
        localStorage.setItem(
          'changeAdviceCode',
          state.orderInfo.medicalAdviceCode,
        )
        router.push({ path: '/prescription/invoice' })
      }
      // 知情同意书点击
      const agreeChange = val => {
        if (val.length > 0) state.disabled = false
        else state.disabled = true
      }

      return {
        confirm,
        agreeChange,
        ...toRefs(state),
        payment,
        openInvoice,
        openUsage,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .content {
    border: 1px solid var(--basic-border-color);
    border-top: none;

    .totalContent {
      .title {
        opacity: 0.5;
      }

      p:last-of-type {
        background: var(--basic-price);
        padding: 16px;
        // background: ;
        text-align: left;

        span {
          font-size: 17px;
          display: inline-block;
          width: 32%;
        }
      }
    }

    .title {
      height: 40px;
      padding-left: 10px;
      line-height: 40px;
      border-bottom: 1px solid var(--basic-border-color);

      span {
        padding: 2px 10px;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        background: var(--basic-green);
      }
    }

    ul {
      li {
        padding: 16px;
        border-bottom: 1px solid var(--basic-border-color);

        span:first-of-type {
          color: var(--basic-labe);
        }

        div {
          p {
            display: inline-block;
            width: 48%;
          }

          p:last-of-type {
            border: none;
            padding-left: 10px;
          }
        }
      }
    }
  }

  .btnContent {
    padding-top: 20px;
    width: 100%;
    text-align: center;
    position: fixed;
    background: #fff;
    bottom: 0;
    button {
      width: 80%;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
    }
  }

  .seeInfoContent {
    padding: 10px 20px 20px 20px;
    text-align: center;

    button {
      width: 50%;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
    }
  }
  ::v-deep .van-dialog__footer {
    display: none;
  }
  .button-content {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    button {
      width: 50% !important;
    }
  }
</style>
